
import { Moon, Sun } from "lucide-react"
import { useTheme } from "@/shared/components/theme/theme-provider"
import { Button } from "@/shared/components/ui/button"

export function ThemeToggle() {
  const { setTheme, theme } = useTheme()

  const resolvedTheme = (() => {
    if (theme === "system") {
      if (typeof window !== "undefined") {
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
      }
      return "dark"
    }
    return theme
  })()

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setTheme(resolvedTheme === "light" ? "dark" : "light")}
      className="relative"
    >
      <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Cambia tema</span>
    </Button>
  )
}
